import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/@lit/reactive-element/reactive-element.js';
import { html as $ } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { property as e } from '../../../../node_modules/@lit/reactive-element/decorators/property.js';
import '../../../../node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import { BaseWithUtils } from '../../lit-mixins/base-with-utils/index.js';
import '../../atoms/buttons/enums.js';
import { isRTL } from '../../utilities/dom-helpers/index.js';
import css_248z from './styles/text-block.scss.js';
import css_248z$1 from './styles/groupsite-text-block.scss.js';
import { StyleTypes } from './types.js';
import '../../molecules/video-player/index.js';
import '../../molecules/lightbox/index.js';
import '../video-block/index.js';

const LitElementWithUtils = BaseWithUtils(s);
class TextBlock extends LitElementWithUtils {
    constructor() {
        super(...arguments);
        this.styleType = StyleTypes.GREY;
        this.textAlignment = 'center';
        this.mediaAlignment = 'left';
        this.rtl = false;
        this.isGroupsite = false;
        this.isInCarousel = false;
    }
    isSlotElementEmpty(name) {
        const element = this.shadowRoot.querySelector(`[name="${name}"]`);
        return element.assignedNodes().length === 0;
    }
    getElement(attribute) {
        return this.shadowRoot.querySelector(attribute);
    }
    firstUpdated() {
        const mediaSlot = this.shadowRoot.querySelector('slot[name="media-block"]');
        const textBlock = this.shadowRoot.querySelector('.text-block');
        if (!mediaSlot.assignedElements()[0]) {
            const alignmentClass = `align-${this.textAlignment}`;
            textBlock.classList.add(alignmentClass);
            textBlock.classList.add('no-media');
        }
        else {
            const mediaAlignmentClass = `align-media-${this.mediaAlignment}`;
            textBlock.classList.add(mediaAlignmentClass);
        }
        const richText = this.shadowRoot.querySelector('slot[name="rich-text"]');
        // eslint-disable-next-line prefer-destructuring
        this._richTextDiv = richText.assignedElements()[0];
        if (this.isSlotElementEmpty('media-block'))
            this.getElement('.media-container').style.display = 'none';
        if (this.isGroupsite)
            this.getElement('.cta-container').classList.add('groupsite');
        if (this.isInCarousel)
            this._richTextDiv.classList.add('carousel');
        if (document.querySelector('parallax-bg')) {
            this.renderRoot.querySelector('.text-block').classList.add('remove-bg');
            this._richTextDiv.classList.add('remove-bg');
        }
        const parent = this.parentNode;
        if (parent === null || parent === void 0 ? void 0 : parent.classList.contains('cvt-layout-text-two-column__col')) {
            textBlock.classList.add('in-two-columns');
        }
        const videoBlock = mediaSlot.assignedElements()[0];
        if (videoBlock && videoBlock.tagName.toLowerCase() === 'video-block') {
            videoBlock.addEventListener('lightbox-opened', () => {
                setTimeout(() => {
                    var _a;
                    const lightbox = (_a = videoBlock.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('light-box');
                    const slotContent = lightbox === null || lightbox === void 0 ? void 0 : lightbox.querySelector('slot[name="content"]');
                    if (slotContent) {
                        const assignedNodes = slotContent.assignedNodes();
                        // eslint-disable-next-line no-console
                        console.log('Lightbox content nodes:', assignedNodes);
                    }
                }, 100);
            });
        }
    }
    updated() {
        this.rtl || isRTL()
            ? this._richTextDiv.classList.add('rtl')
            : this._richTextDiv.classList.remove('rtl');
    }
    render() {
        var _a;
        const styleClass = `style-${this.styleType}`;
        return $ `<div class="text-block ${(_a = this.utilityClasses) !== null && _a !== void 0 ? _a : ''} ${styleClass} ${this.rtl || isRTL() ? 'rtl' : ''} ${this.isInCarousel ? 'carousel' : ''}" dir="${this.rtl || isRTL() ? 'rtl' : 'ltr'}"><div class="media-container"><slot name="media-block"></slot></div><div class="content-container"><slot name="rich-text"></slot><div class="cta-container"><slot name="primary-cta"></slot><slot name="secondary-cta"></slot></div></div></div>`;
    }
}
TextBlock.styles = [LitElementWithUtils.styles || [], css_248z, css_248z$1];
__decorate([
    e({ type: String })
], TextBlock.prototype, "styleType", void 0);
__decorate([
    e({ type: String })
], TextBlock.prototype, "textAlignment", void 0);
__decorate([
    e({ type: String })
], TextBlock.prototype, "mediaAlignment", void 0);
__decorate([
    e({ type: Boolean })
], TextBlock.prototype, "rtl", void 0);
__decorate([
    e({ type: Boolean })
], TextBlock.prototype, "isGroupsite", void 0);
__decorate([
    e({ type: Boolean })
], TextBlock.prototype, "isInCarousel", void 0);
customElements.define('text-block', TextBlock);

export { TextBlock };
